export default function SectionDivider() {
  return (
    <div aria-hidden="true" className="py-20 lg:py-28">
      <div className="mx-auto h-1 w-16 rounded-full bg-ups-primary" />
    </div>
  )
}
